/**
 * Topbar Component
 */

import { useAuthStore } from '@/store/auth';
import { useVendorStore } from '@/store/vendor';
import { logout } from '@/lib/auth';
import { useNavigate } from 'react-router-dom';
import WSStatus from './WSStatus';
import ThemeToggle from './ThemeToggle';

export default function Topbar() {
  const navigate = useNavigate();
  const { vendor, clearAuth } = useAuthStore();
  const vendorStatus = useVendorStore((state) => state.status);

  const handleLogout = async () => {
    await logout();
    clearAuth();
    navigate('/login', { replace: true });
  };

  // Sprint 27: Updated to match database enum
  const statusColors: Record<string, string> = {
    active: 'bg-green-500',
    inactive: 'bg-gray-400',
    pending: 'bg-yellow-500',
    suspended: 'bg-red-500',
  };

  return (
    <div className="h-16 bg-card border-b border-border flex items-center justify-between px-6">
      {/* Left: Vendor Info */}
      <div className="flex items-center gap-4">
        <div>
          <h3 className="font-semibold text-foreground">{vendor?.name || 'Loading...'}</h3>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <div className={`w-2 h-2 rounded-full ${statusColors[vendorStatus]}`} />
            <span className="capitalize">{vendorStatus}</span>
            {vendor?.zoneName && (
              <>
                <span>•</span>
                <span>{vendor.zoneName}</span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-4">
        <WSStatus />
        <ThemeToggle />

        {/* User Menu */}
        <button
          onClick={handleLogout}
          className="px-4 py-2 text-sm font-medium text-foreground hover:bg-accent rounded-lg transition-colors"
        >
          Logout
        </button>
      </div>
    </div>
  );
}

